import Swal from "sweetalert2";
import { fetchConToken, fetchSinToken } from "../../helpers/fetch";
import { types } from "../../types/types";
import { getLocalStorage, setLocalStorage } from "../../helpers/localStorage";
import { setCityCode, setUserCity } from "../ui/ui";

export const PROFILE_FLAG = "pc-flag";

export const startLogin = (email, password) => {
  return async (dispatch) => {
    const resp = await fetchSinToken(
      "api/users/login",
      { email, password },
      "POST"
    );
    const body = await resp.json();

    if (body.status === 200) {
      const token = body.data.token;
      setLocalStorage("token-adm", token);
      setLocalStorage("token-init-date", new Date().getTime());

      const rpta = await fetchConToken("api/users/get/admin", {}, "GET");
      const body2 = await rpta.json();
      if (body2.status === 200) {
        const { id, name, role, is_super_admin, city_id, jugnoId, merchantId, isProfileComplete } = body2.data;
        setLocalStorage(PROFILE_FLAG, Number(isProfileComplete ?? 0));
        dispatch(
          login({
            uid: id,
            name,
            role,
            isSuperAdmin: is_super_admin,
            cityId: city_id,
            jugnoId,
            merchantId,
            isProfileComplete,
          })
        );
        if (jugnoId) {
          if (city_id) {
            dispatch(setUserCity(city_id));
          }
        } else {
          const savedCity = localStorage.getItem("city");
          if (!savedCity) {
            dispatch(setUserCity(city_id || 6));
          } else {
            try {
              const parsed = JSON.parse(savedCity);
              if (parsed && (parsed.id !== undefined && parsed.id !== null)) {
                dispatch(setCityCode(Number(parsed.id)));
              } else {
                dispatch(setUserCity(city_id || 6));
              }
            } catch (e) {
              dispatch(setUserCity(city_id || 6));
            }
          }
        }
      } else {
        Swal.fire({
          title: "Error!",
          text: body.message,
          icon: "error",
        });
      }
    } else {
      Swal.fire({
        title: "Error!",
        text: body.message,
        icon: "error",
      });
    }
  };
};

const login = (user) => ({
  type: types.authLogin,
  payload: user,
});

export const setProfileComplete = () => {
  setLocalStorage(PROFILE_FLAG, 1);
  return { type: types.authLogin, payload: { isProfileComplete: 1 } };
};

export const startLogout = () => {
  return (dispatch) => {
    localStorage.clear();
    sessionStorage.removeItem("notif-banner-dismissed");
    dispatch(logout());
  };
};

const logout = () => ({
  type: types.authLogout,
});

const notifySessionClosed = () => {
  Swal.fire({
    icon: "info",
    title: "Tu sesión se ha cerrado",
    html: "Por tu seguridad cerramos tu sesión y necesitamos verificar tu identidad.<br/>Vuelve a iniciar sesión para continuar.",
    confirmButtonColor: "#7de2a5",
  });
};

export const startChecking = () => {
  return async (dispatch) => {
    const token = getLocalStorage("token-adm");
    const flag = getLocalStorage(PROFILE_FLAG);

    //flag presente sin token
    if (!token) {
      if (flag !== null) dispatch(startLogout());
      return;
    }

    //flag ausente o manipulada 
    if (flag !== "0" && flag !== "1") {
      dispatch(startLogout());
      notifySessionClosed();
      return;
    }

    const rpta = await fetchConToken("api/users/get/admin", {}, "GET");
    const body = await rpta.json();

    //el server no confirma un estado válido 
    if (body.status !== 200 || body.data?.isProfileComplete === undefined) {
      dispatch(startLogout());
      notifySessionClosed();
      return;
    }

    const { id, name, role, city_id, jugnoId, merchantId } = body.data;
    const isProfileComplete = Number(body.data.isProfileComplete ?? 0);
    dispatch(
      login({
        uid: id,
        name,
        role,
        isSuperAdmin: body.data.is_super_admin,
        cityId: city_id,
        jugnoId,
        merchantId,
        isProfileComplete,
      })
    );
    if (jugnoId) {
      if (city_id) {
        dispatch(setUserCity(city_id));
      }
    } else {
      const savedCity = localStorage.getItem("city");
      if (!savedCity) {
        dispatch(setUserCity(city_id || 6));
      } else {
        try {
          const parsed = JSON.parse(savedCity);
          if (parsed && (parsed.id !== undefined && parsed.id !== null)) {
            dispatch(setCityCode(Number(parsed.id)));
          } else {
            dispatch(setUserCity(city_id || 6));
          }
        } catch (e) {
          dispatch(setUserCity(city_id || 6));
        }
      }
    }
  };
};

export const putUser = async ({ id, params }) => {
  const rpta = await fetchConToken(`api/users/${id}`, params, "PUT");
  const body = await rpta.json();
  return body;
};

export const changePassword = async ({ id, password }) => {
  const rpta = await fetchConToken(
    `api/users/change-password/${id}`,
    { password },
    "PUT"
  );
  const body = await rpta.json();
  return { ok: rpta.ok, status: rpta.status, data: body };
};
